import { ApplicationLayout } from "melco-ui";

import { ControlCenterMainNavigation } from "../navigation/ControlCenterMainNavigation";
import { useAppDomain } from "../../hooks/appdomain/useAppDomain";
import { createRef } from "react";
import { ControlCenterSecondaryNavigation } from "../navigation/ControlCenterSecondaryNavigation";

type MelcoControlCenterApplicationLayoutProps = {
    children?: React.ReactNode;
};

const MelcoControlCenterApplicationLayout: React.FC<MelcoControlCenterApplicationLayoutProps> = ({
    children,
}) => {
    const { footertext } = useAppDomain();
    const contentAreaRef = createRef<HTMLDivElement>();

    return (
        <ApplicationLayout
            mainNavigation={<ControlCenterMainNavigation />}
            footer={footertext}
            contentAreaRef={contentAreaRef}
        >
            {children}
            <ControlCenterSecondaryNavigation />

        </ApplicationLayout>
    );
};

export default MelcoControlCenterApplicationLayout;
